<template>
  <NavbarOne />
  <PageBanner />
  <Products />
  <SubscribeContent />
  <MainFooter class="bg-black" />
  <CopyRight />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useHead } from "@unhead/vue";
import NavbarOne from "@/components/Layouts/NavbarOne.vue";
import PageBanner from "@/components/Products/PageBanner.vue";
import Products from "@/components/Products/index.vue";
import SubscribeContent from "@/components/Common/SubscribeContent.vue";
import MainFooter from "@/components/Layouts/MainFooter.vue";
import CopyRight from "@/components/Layouts/CopyRight.vue";

export default defineComponent({
  name: "ProductsPage",
  components: {
    NavbarOne,
    PageBanner,
    Products,
    SubscribeContent,
    MainFooter,
    CopyRight,
  },
  setup() {
    useHead({
      title: "اشتراكات IPTV | جميع الباقات والخدمات",
      meta: [
        {
          name: "description",
          content:
            "استعرض جميع اشتراكات IPTV المتوفرة، بما في ذلك باقات القنوات العربية والعالمية، الأفلام، المسلسلات، القنوات الرياضية، وخدمات البث بجودة HD و4K.",
        },
        {
          name: "keywords",
          content:
            "اشتراكات IPTV, باقات IPTV, IPTV HD, IPTV 4K, قنوات عربية, قنوات عالمية, قنوات رياضية, أفلام, مسلسلات",
        },
        {
          property: "og:title",
          content: "اشتراكات IPTV | جميع الباقات والخدمات",
        },
        {
          property: "og:description",
          content:
            "استعرض جميع باقات وخدمات IPTV واختر الاشتراك المناسب لك مع أفضل جودة وأداء.",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "robots",
          content: "index, follow",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://karamtv4k.com/products",
        },
      ],
    });
  },
});
</script>